/**
 * Pipeline symbol shared types.
 * Keep category / family unions here so catalog + drawers stay in sync.
 */
/** Local glyph canvas size (px). */
export var PIPELINE_GLYPH_SIZE = 48;
